import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

export interface SendReceiptRequest {
  paymentId: string;
  email: string;
}

export interface SendReceiptResponse {
  success: boolean;
}

export const useSendReceiptMutation = (
  options?: UseMutationOptions<SendReceiptResponse, Error, SendReceiptRequest, unknown>
): UseMutationResult<SendReceiptResponse, Error, SendReceiptRequest, unknown> => {
  return useMutation<SendReceiptResponse, Error, SendReceiptRequest, unknown>({
    ...options,
  });
};
